
<script>
	import options from './ProductCarousel.options'

	export default options
</script>

<template>
	<article class="nlx-product-carousel">

		<template v-if="currentCardType.data && currentCardType.data.length">

			<div class="nlx-product-carousel__title-container">
				<h2 class="nlx-product-carousel__title">{{carouselTitle}}</h2>
				<a v-if="carouselViewAllLink" :href="carouselViewAllLink" class="nlx-product-carousel__slide-arrows-text" :class="hasMoreCarouselItemsThanFour ? '' : 'nlx-product-carousel__slide-arrows-text--no-spacing'">{{carouselViewAllLinkText}}</a>
			</div>

			<div :class="`glide-${indexFromProps}`" class="nlx-product-carousel__glide-area">

				<section v-if="hasMoreCarouselItemsThanFour" class="glide__arrows nlx-product-carousel__slide-arrows-container" data-glide-el="controls">
					<button class="glide__arrow glide__arrow--left" data-glide-dir="<">
						<div class="nlx-product-carousel__slide-arrows-icon-container" v-html="arrowLongSVG_orientationLeft"></div>
					</button>
					<button class="glide__arrow glide__arrow--right" data-glide-dir=">">
						<div class="nlx-product-carousel__slide-arrows-icon-container" v-html="arrowLongSVG_orientationRight"></div>
					</button>
				</section>

				<section class="glide__track" data-glide-el="track">
					<ul class="glide__slides">
						<template v-for="(carouselItem, index) in currentCardType.data" :key="index">
							<li class="glide__slide nlx-product-carousel__carousel-item-container">
								<component :is="currentCardType.name" :[currentCardType.propName]="carouselItem"></component>
							</li>
						</template>
					</ul>
				</section>

				<section v-show="showScrollbar" class="glide__bullets" data-glide-el="controls[nav]">
					<template v-for="(bullet, index) in currentCardType.data" :key="index">
						<button class="glide__bullet" :data-glide-dir="`=${index}`"></button>
					</template>
				</section>

			</div>
		</template>

	</article>
</template>



